import { analyticsBootstrapService } from "@/services/analyticsBootstrap.service";
import { analytics } from "@/services/analytics.service";
import type { StoreLinkSurface } from "@/lib/storeLinks";

export type MarketingCtaDestination = "app_store" | "play_store" | "signup_login";

export type MarketingCtaPlacement =
  | "header"
  | "hero"
  | "body"
  | "article_inline"
  | "final_cta"
  | "footer"
  | "mobile_landing";

interface MarketingCtaClick {
  destination: MarketingCtaDestination;
  /** Which page/area of the site the CTA lives on; matches the link's ct/utm_campaign tag. */
  surface: StoreLinkSurface;
  placement: MarketingCtaPlacement;
  label: string;
  href: string;
  ctaId?: string;
}

const GOOGLE_ANALYTICS_EVENT_BY_DESTINATION: Record<MarketingCtaDestination, string> = {
  app_store: "app_store_cta_click",
  play_store: "play_store_cta_click",
  signup_login: "signup_login_cta_click",
};

export function trackMarketingCtaClick({ destination, surface, placement, label, href, ctaId }: MarketingCtaClick): void {
  if (typeof window === "undefined") return;

  const params = {
    surface,
    cta_destination: destination,
    cta_placement: placement,
    cta_label: label,
    cta_id: ctaId ?? `${surface}:${placement}:${destination}`,
    link_url: href,
    page_location: window.location.href,
    page_path: `${window.location.pathname}${window.location.search}`,
    page_title: document.title,
    transport_type: "beacon",
  };

  const eventName = GOOGLE_ANALYTICS_EVENT_BY_DESTINATION[destination];
  analyticsBootstrapService.trackGoogleAnalyticsEvent(eventName, params);
  analytics.capture(eventName, params);
}
